import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: 'upload-framework-dialog',
  templateUrl: './uploadFrameworkDialog.component.html'
})
export class UploadFrameworkDialogComponent {
  frameworkForm: FormGroup;
  file: File | null = null;
  src: string | null = null;
  name = '';

  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<UploadFrameworkDialogComponent>
  ) {
    this.frameworkForm = this._formBuilder.group({
      name: ['', Validators.required]
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.file = input.files[0];

      const reader = new FileReader();
      reader.onload = () => {
        this.src = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.frameworkForm.valid && this.file) {
      this.dialogRef.close({
        name: this.frameworkForm.value.name,
        file: this.file,
        src: this.src
      });
    }
  }
}
